import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Button
} from "@mui/material";

import precampagnaApi from "../../api/preCampagnaApi";
import BackButtonDesktop from "../../components/BackButtonDesktop";
import { formatDate } from '../../utils/dateFormatter';

export default function PreCampagnaListPageMobile() {

  const [leads, setLeads] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const pageSize = 10;

  useEffect(() => {
    fetchLeads(0);
  }, []);

  const fetchLeads = async (page) => {

    try {

      const params = {
        page,
        size: pageSize,
        sort: "createdAt,DESC"
      };

      const res = await precampagnaApi.list(params);
      console.log("res",JSON.stringify(res.data.content));
      setLeads(res.data.content || []);
      setTotalPages(res.totalPages || 0);
      setPage(res.number || 0);

    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Container>

      <BackButtonDesktop />

      <Typography variant="h4" sx={{ mb: 3 }}>
        Iscritti Pre-Campagna
      </Typography>

      <Table>

        <TableHead>
          <TableRow>
            <TableCell>Email</TableCell>
            <TableCell>Nome</TableCell>
            <TableCell>Cognome</TableCell>
            <TableCell>Data Registrazione</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {leads.map((l) => (

            <TableRow key={l.email}>
              <TableCell>{l.email}</TableCell>
              <TableCell>{l.nome}</TableCell>
              <TableCell>{l.cognome}</TableCell>
              <TableCell>{formatDate(l.createdAt)}</TableCell>
            </TableRow>

          ))}
        </TableBody>

      </Table>

      {/* PAGINAZIONE */}

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>

        {Array.from({ length: totalPages }, (_, i) => (

          <Button
            key={i}
            variant={i === page ? "contained" : "outlined"}
            onClick={() => fetchLeads(i)}
          >
            {i + 1}
          </Button>

        ))}

      </Stack>

    </Container>
  );
}